<template>
  <b-table v-bind="tableAttributes" :items="items" :fields="fields">
    <template #cell(type)="data">
      {{ setType(data.item.type) }}
    </template>

    <template #cell(feature_attributes)="data">
      <span>
        <span
            class="ml-2 badge badge-primary text-wrap"
            v-for="(value, index) in data.item.feature_attributes"
            :key="index"
        >
          {{ setFeatureValue(value.value, data.item.type) }}
        </span>
      </span>
    </template>

    <template #cell(action)="data">
      <div v-if="restoreState == true">
        <span class="h5" v-b-tooltip.hover title="حذف دائمی">
          <b-icon icon="trash" @click="ForceDeleteFeature(data.item)"></b-icon>
        </span>
        <span class="h5" v-b-tooltip.hover title="بازگردانی">
          <b-icon
              icon="arrow-clockwise"
              class="mr-3"
              @click="restoreFeature(data.item)"
          ></b-icon>
        </span>
      </div>
      <div v-else>
        <span
            class="h5"
            @click="removeFeature(data.item)"
            v-b-tooltip.hover
            title="حذف"
        >
          <b-icon icon="trash"></b-icon>
        </span>

        <span class="h5" v-b-tooltip.hover title="ویرایش">
          <router-link
              :to="{ name: 'UpdateFeature', params: { id: data.item.id } }"
          >
            <b-icon icon="pencil" class="mr-3"></b-icon>
          </router-link>
        </span>
      </div>
    </template>
  </b-table>
</template>
<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {featureTypes} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Feature";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "tableItemOfFeatures",
  props: ["items", "restoreState"],
  data() {
    return {
      dateConverter,
      featureTypes,
      tableAttributes,
      fields: [
        {key: "name", label: "نام"},
        {key: "public_name", label: "نام عمومی"},
        {key: "type", label: "نوع"},
        {key: "feature_attributes", label: "خصوصیات ویژگی محصول"},
        {key: "action", label: ""},
      ],
    };
  },
  methods: {
    setType(type) {
      const findFeatureObject = this.featureTypes.find(obj => obj.value === type);
      return findFeatureObject.text
    },
    removeFeature(item) {
      this.$store.dispatch("Feature/removeFeature", item);
    },

    restoreFeature(item) {
      this.$store.dispatch("Feature/restoreFeature", item);

    },
    ForceDeleteFeature(item) {
      this.$store.dispatch("Feature/forceDeleteFeature", item);
    },
    setFeatureValue(item, itemType) {
      if (itemType == 'date') {
        return this.dateConverter(item);
      }
      return item
    }
  },
};
</script>